import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class AppLoadService {
  constructor(private httpClient: HttpClient) {}

  private commonIcons(): Promise<any> {
    const promise = this.httpClient
      .get('assets/images/symbol-defs.svg?v=' + environment.version, { responseType: 'text' })
      .toPromise()
      .then((data) => {
        var div = document.createElement('div');
        div.innerHTML = data;
        document.body.insertBefore(div, document.body.childNodes[0]);

        return data;
      });

    return promise;
  }

  private brandIcons(): Promise<any> {
    const promise = this.httpClient
      .get('assets/images/symbol-defs-b.svg?v=' + environment.version, { responseType: 'text' })
      .toPromise()
      .then((data) => {
        var div = document.createElement('div');
        div.innerHTML = data;
        document.body.insertBefore(div, document.body.childNodes[0]);

        return data;
      });

    return promise;
  }

  load(): Promise<any> {
    return this.commonIcons().then((firstResult: any) => this.brandIcons().then((secondResult: any) => {}));
  }
}
